export default __webpack_public_path__ + "77be0570f7c27396ee748019ffd3eeb5.png";